<table class="table table-white table-hover table-condensed" *ngIf="client.CustomerContacts.length">
    <thead>
        <tr>
            <th>Name</th>
            <th>Email</th>
            <th translate="general.address.mobile"></th>
            <th>&nbsp;</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let client of client?.CustomerContacts">
            <ng-container *ngIf="!client.IsDeleted">
                <td>
                    <a (click)="viewClient(client)"> {{ client.FirstName }} {{ client.LastName }} </a>
                </td>
                <td>{{ client.Email }}</td>
                <td>{{ client.Mobile | phoneNumberLocalize }}</td>
                <td class="text-right" style="min-width: 100px">
                    <a
                        class="cta btn btn-xs btn-default"
                        (click)="emailClient(client)"
                        tooltip="Email client"
                        container="body"
                        *ngIf="canSendEmail">
                        <i class="ti-email"></i>
                    </a>
                    <a
                        class="cta btn btn-xs btn-default"
                        (click)="smsClient(client)"
                        tooltip="SMS client"
                        container="body"
                        *ngIf="canSendSms">
                        <i class="ti-mobile"></i>
                    </a>
                    <a
                        class="cta btn btn-xs btn-danger"
                        (click)="deleteClient($event, client)"
                        tooltip="Delete"
                        container="body"
                        *ngIf="permissionService.isAvailable('customers.maintain-customer-contacts.delete-contacts')">
                        <i class="ti-trash"></i>
                    </a>
                </td>
            </ng-container>
        </tr>
    </tbody>
</table>
